// extracted by mini-css-extract-plugin
module.exports = {"root":"more-articles_root__HHaUu","title":"more-articles_title__4ARbc","newCards":"more-articles_newCards__SGzXG"};